module.exports = __webpack_public_path__ + "static/dusanstvo_sluzby_2-4e9e8fc7c7a2fc7215ce9392d98808a1.jpg";